import { render, staticRenderFns } from "./PlanDialog.vue?vue&type=template&id=2d0550dc&scoped=true&"
import script from "./PlanDialog.vue?vue&type=script&lang=js&"
export * from "./PlanDialog.vue?vue&type=script&lang=js&"
import style0 from "./PlanDialog.vue?vue&type=style&index=0&id=2d0550dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0550dc",
  null
  
)

export default component.exports